import { lazy } from 'react'
import classNames from 'classnames'

import type { SyncState } from '@/libraries/forms'

import { H2 } from './H2'

const SyncStatus = lazy(
  () => import('@/libraries/forms/SyncStatus')
    .then(m => ({ default: m.SyncStatus })),
)

interface PageSectionProps {
  title: React.ReactNode
  syncStatus?: SyncState
  introText?: React.ReactNode
  children: React.ReactNode
  toolbar?: React.ReactNode
  className?: string
}

export function PageSection({ title, syncStatus, introText, toolbar, children, className }: PageSectionProps) {
  return <section className={classNames('mb-10', className)}>
    <ToolbarContainer>
      <H2 className="">{title}</H2>
      {syncStatus && <SyncStatus state={syncStatus} className="mt-1.5" />}
      {introText && <>
        <div className="w-full" />
        <div>{introText}</div>
      </>}
      {toolbar &&
        <div className={classNames(introText ? 'justify-end' : '@min-[50cqw]:justify-end', 'grow flex print:hidden')}>
          {toolbar}
        </div>
      }
    </ToolbarContainer>
    {children}
  </section>
}

export function ToolbarContainer({ children, className }: { children: React.ReactNode, className?: string }) {
  return <div className={classNames(className, '@container flex flex-wrap items-center gap-x-4 gap-y-2 mb-4')}>
    {children}
  </div>
}
